<template>
  <div class="col-md-10 col-lg-10 offset-md-1 offset-lg-1 page">
    <div class="header2">
      <h1 class="title">CPT Billing</h1>
      <help-icon help-id="cpt" title="Help for CPT Billing" />
    </div>
    <AccordionComponent :multiple="true">
      <template v-for="(patient, index) in patientList">
        <AccordionTab
          v-if="cptData && patient.externId in cptData"
          :header="`${patient.firstName} ${patient.lastName}`"
          :key="'toptab' + index"
        >
          <AccordionComponent :multiple="true">
            <AccordionTab
              v-for="(meters, cptCode) in cptData[patient.externId].cptList"
              :header="
                cptCode +
                ' (' +
                getICDList(cptData[patient.externId].icdList, cptCode).join(', ') +
                ')'
              "
              :key="'secondtab' + cptCode"
            >
              <div class="data">
                <template v-if="cptData[patient.externId].historical[cptCode]">
                  <div
                    v-for="(record, index2) in cptData[patient.externId].historical[cptCode]"
                    class="datarow historicalData"
                    :key="'historicalData' + index2"
                  >
                    <span class="date1">{{ `${record.firstDate} to ` }}</span
                    ><span
                      class="date2"
                      :style="[
                        record.status == 1
                          ? { 'font-weight': 'bold', color: '#688dd0' }
                          : {},
                      ]"
                      >{{ `${record.lastDate}` }}</span
                    >
                    <span
                      class="billStatus"
                      @click="record.status == 1 && handleBill(record)"
                      :style="[
                        record.status == 1
                          ? { 'font-weight': 'bold', color: '#688dd0', cursor: 'pointer' }
                          : record.status == 0
                          ? { color: '#7e91a4' }
                          : {},
                      ]"
                      >{{
                        { 0: "Not Billable", 1: "Billable", 2: "Billed" }[record.status]
                      }}</span
                    >
                  </div>
                </template>
                <div
                  v-if="cptData[patient.externId].current[cptCode]"
                  class="datarow currentData"
                >
                  <span class="date1">{{
                    `${cptData[patient.externId].current[cptCode].firstDate} to `
                  }}</span
                  ><span
                    class="date2"
                    :style="[
                      cptData[patient.externId].current[cptCode].status == 1
                        ? { 'font-weight': 'bold', color: '#688dd0' }
                        : {},
                    ]"
                    >{{ cptData[patient.externId].current[cptCode].lastDate }}</span
                  >
                  <span
                    class="billStatus"
                    @click="
                      cptData[patient.externId].current[cptCode].status == 1 &&
                        handleBill(cptData[patient.externId].current[cptCode])
                    "
                    :style="[
                      cptData[patient.externId].current[cptCode].status == 1
                        ? { 'font-weight': 'bold', color: '#688dd0', cursor: 'pointer' }
                        : cptData[patient.externId].current[cptCode].status == 0
                        ? { color: '#7e91a4' }
                        : {},
                    ]"
                    >{{
                      { 0: "Not Billable", 1: "Billable", 2: "Billed" }[
                        cptData[patient.externId].current[cptCode].status
                      ]
                    }}</span
                  >
                </div>
                <div class="datarow meterList">
                  <span><b>Assigned Devices: </b>{{ meterListGenerator(meters) }}</span>
                </div>
              </div>
            </AccordionTab>
          </AccordionComponent>
        </AccordionTab>
      </template>
    </AccordionComponent>
    <div v-if="billingRecord" id="icd-assign-modal" class="icd-assign-modal">
      <div class="inner-assign-modal">
        <div class="form-group2">
          <label>Select an ICD-10 to submit this billing period</label>
          <select v-model="billingIcd" class="form-control2">
            <option
              v-for="option in getICDList(
                cptData[billingRecord.pid].icdList,
                billingRecord.cpt
              )"
              :value="option"
              :key="option"
            >
              {{ option }}
            </option>
          </select>
        </div>
        <div class="btn-group">
          <button type="submit" class="btn btn-primary" @click="submitBilling">
            Bill
          </button>
          <button type="button" class="btn btn-secondary" @click="closeBilling">
            Cancel
          </button>
        </div>
      </div>
    </div>
    <!-- <div class="p-accordion p-component">
            <accordion class="p-accordion-tab">
                <accordion-tab v-for="(patient,index) in patientList" :header="patient.externId" :key="index" class="p-accordion-header">
                    TESTING
                </accordion-tab>
            </accordion>
        </div> -->
  </div>
</template>

<script>
import { CURR_API, OTHER_API } from "@/constants/apis";
import axios from "axios";
import { mapGetters } from "vuex";
import { getFormattedRelationsList } from "@/data/getters";
import HelpIcon from "@/components/help/HelpIcon.vue";

export default {
  name: "CptBilling",
  components: {
    HelpIcon,
  },
  data() {
    return {
      cptData: null,
      billingRecord: null,
      billingIcd: null,
    };
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
    }),
    patientList: function () {
      let plist = getFormattedRelationsList(this.allData);
      return plist.filter((patient) => !patient.admin);
    },
  },
  async mounted() {
    // this.getPatientCpts()
    this.getPatientCpts2();
  },
  methods: {
    getICDList(list, cpt) {
      let uniqueList = [
        ...new Set(
          list.filter((el) => el.cpt == cpt && el.icd != "").map((el2) => el2.icd)
        ),
      ];
      return uniqueList;
    },
    handleBill(record) {
      this.billingRecord = record;
    },
    async submitBilling() {
      let content = {
        PatientCpt: {
          API_Meth: "MarkBilled",
          fid: this.billingRecord.fid,
          current: this.billingRecord.fidNextCycle ? 0 : 1,
          icd: this.billingIcd
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.status == "Success") {
            this.billingRecord = null
            this.billingIcd = null
            alert("Successful billing.")
          } else {
            alert("Failure with billing. Please contact an administrator.");
          }
        });
    },
    closeBilling() {
      this.billingRecord = null;
      this.billingIcd = null;
    },
    meterListGenerator(meters) {
      let newArr = meters.map((meter) => {
        return `${meter[0]} (${meter[1]})`;
      });
      return newArr.join(", ");
    },
    async getPatientCpts2() {
      let content = {
        PatientCpt: {
          API_Meth: "GetPatientCptBilling2",
          pids: this.patientList.map((patient) => patient.externId),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then(
          (res) => {
            this.cptData = res.data;
            // console.log(this.cptData)
          },
          (error) => {
            alert("Error: Check the console log");
            console.log(error);
          }
        );
    },
    async getPatientCpts() {
      let content = {
        PatientCpt: {
          API_Meth: "GetPatientCptBilling",
          pids: this.patientList.map((patient) => patient.externId),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then(
          (res) => {
            if (!Array.isArray(res.data)) {
              this.cptData = Object.fromEntries(
                Object.entries(res.data).filter(
                  ([key, value]) => !Array.isArray(value.current)
                )
              );
              console.log(this.cptData);
            }
          },
          (error) => {
            alert("Error: Check the console log");
            console.log(error);
          }
        );
    },
    getHistorical(externId, cptCode, meter) {
      let historical = this.cptData[externId].historical;
      if (historical[cptCode] && historical[cptCode][meter])
        return historical[cptCode][meter];
      return {};
    },
  },
};
</script>

<style scoped lang="scss">
.header2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  //   color: #0060ff;
}
.header2 .title {
  margin: 0;
  flex: 1;
  text-align: center;
}
.billStatus {
  float: right;
}
.data {
  display: flex;
  flex-direction: column-reverse;
}

.icd-assign-modal {
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.inner-assign-modal {
  background: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 100%;
}

.form-group {
  margin-bottom: 20px;
}

.form-group2 label {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 14px;
}

.form-control2 {
  display: block;
  width: 100%;
  height: 40px;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: none;
}

.btn-group {
  display: flex;
  justify-content: flex-end;
}

.btn-primary,
.btn-secondary {
  height: 40px;
  padding: 0 20px;
}
</style>
